import { gql } from '@apollo/client';
/**
 * Guarda un horario dado un nombre y los grupos que se van a guardar
 */
export default gql`
  mutation SaveScheduleMutation($name: String, $groups: [UserGroup!]!) {
    saveSchedule(name: $name, groups: $groups)
  }
`;
